export default __webpack_public_path__ + "static/media/banner-2.07a92ad3.jpg";